import { useAppSelector } from "store/store";

export const useLeft = (imageId: string) => {
    const left =
        useAppSelector((store) => store.bulkResize.images.find((image) => image.id === imageId)?.crop.left) || 0;

    return { left };
};
